import clsx from 'clsx';
import { Link, type LinkProps } from '@trg/tlw-ui-component';

export type KeywordProps = LinkProps;

export function Keyword({ className, ...props }: KeywordProps) {
  return (
    <Link
      className={clsx(
        'tlw-txt-zh-mini tlw-text-txt-700 tlw-w-fit tlw-line-clamp-1 tlw-duration-300 hover:tlw-text-txt-core',
        className
      )}
      {...props}
    />
  );
}
